import {useAtom} from 'jotai'

import {
  typeAtom,
  uploadType,
  campaignFiles,
  deleteFileIds,
  uploadFileIds,
  uploadProducts,
  ReferralCampaignProductListAtom,
  referralCampaignProductListAllAtom,
  selectedGiveAwayProductAtom,
  selectedCampaignProductAtom,
} from '../store/list'
import {ProgramDetailAtom} from '../store/program'

export const useReferral = () => {
  const [type, typeSet] = useAtom(typeAtom)
  const [program, programSet] = useAtom(ProgramDetailAtom)
  const [referralCampaignProductList, referralCampaignProductListSet] = useAtom(
    ReferralCampaignProductListAtom
  )
  const [referralCampaignProductListAll, referralCampaignProductListAllSet] = useAtom(
    referralCampaignProductListAllAtom
  )

  const [selectedGiveAwayProduct, selectedGiveAwayProductSet] = useAtom(selectedGiveAwayProductAtom)
  const [selectedCampaignProduct, selectedCampaignProductSet] = useAtom(selectedCampaignProductAtom)

  const [campaignFilesState, campaignFilesSet] = useAtom(campaignFiles)

  const [uploadFileIdsState, uploadFileIdsSet] = useAtom(uploadFileIds)
  const [uploadProductsState, uploadProductsSet] = useAtom(uploadProducts)

  const [deleteFileIdsState, deleteFileIdsSet] = useAtom(deleteFileIds)

  const [uploadTypeState, uploadTypeSet] = useAtom(uploadType)

  return {
    type,
    typeSet,
    program,
    programSet,
    referralCampaignProductList,
    referralCampaignProductListSet,
    referralCampaignProductListAll,
    referralCampaignProductListAllSet,

    selectedGiveAwayProduct,
    selectedGiveAwayProductSet,

    selectedCampaignProduct,
    selectedCampaignProductSet,

    uploadTypeState,
    uploadTypeSet,

    campaignFilesState,
    campaignFilesSet,

    uploadFileIdsState,
    uploadFileIdsSet,

    uploadProductsState,
    uploadProductsSet,

    deleteFileIdsState,
    deleteFileIdsSet,
  }
}
